import { reactive } from "vue";
export const tradeFabMyAssetsContext = reactive({
    albumId: "",
    albumName: "",
    gId: "",
    gNum: "",
    price: ""
});
export function syncTradeFabFromMyAssetsWarehouse(albumId, albumName, g) {
    tradeFabMyAssetsContext.albumId = albumId != null ? String(albumId) : "";
    tradeFabMyAssetsContext.albumName = albumName != null ? String(albumName) : "";
    if (!g || g.gId == null) {
        tradeFabMyAssetsContext.gId = "";
        tradeFabMyAssetsContext.gNum = "";
        tradeFabMyAssetsContext.price = "";
        return;
    }
    tradeFabMyAssetsContext.gId = String(g.gId);
    const gn = g.gNum;
    tradeFabMyAssetsContext.gNum = gn != null && gn !== "" ? String(gn) : "";
    const pc = g.priceCny;
    tradeFabMyAssetsContext.price = pc != null && pc !== "" ? String(pc) : "";
}
export function clearTradeFabMyAssetsContext() {
    tradeFabMyAssetsContext.albumId = "";
    tradeFabMyAssetsContext.albumName = "";
    tradeFabMyAssetsContext.gId = "";
    tradeFabMyAssetsContext.gNum = "";
    tradeFabMyAssetsContext.price = "";
}
